
<template>
  <div>
    <footer class="login-footer"> 
        <div class="content" :class="isSub?'content2':''">
            <div class="footer-content">
                <div class="about-us">
                    <p>Know about us</p>
                    <ul>
                        <li @click="routetoPage('/about')"><a href="javascript:void(0)">About Us</a></li>
                        <li @click="routetoPage('/contactUs')"><a href="javascript:void(0)">Contact Us</a></li>
                        <li @click="routetoPage('/contactUs')"><a href="javascript:void(0)">Suggestions</a></li>
                        <li @click="routetoPage('/recruit')"><a href="javascript:void(0)">Join Us</a></li>
                    </ul>
                </div>
                <div class="email">
                    <p>Contcat Email</p>
                    <ul>
                        <li><span>Customer service：</span> op-9@cnbooking.net</li>
                        <li><span>Hotel and supplier cooperation：</span> chinahotel-1@cnbooking.net</li>
                        <li><span>International cooperation：</span> globalhotel-33@cnbooking.net</li>
                        <li><span>OTA cooperation：</span> channel-3@cnbooking.net</li>
                    </ul>
                </div>
                <div class="ma">
                    <p>Wechat QR code</p>
                    <img src="./../../assets/images/ewm.png" alt="" >
                </div>
            </div>
            <div class="footer-info">
                <div class="footer-logo"><img src="./../../assets/images/foot-logo1.png" alt=""></div>
                <div class="footer-text">
                    Copyright2013-2022,深圳市港捷旅国际旅行社有限公司.All rights reserved.<br/>
                    <a href="https://beian.miit.gov.cn/">粤ICP备09018804号</a> <a href="https://beian.mps.gov.cn/#/query/webSearch"> <img style="vertical-align: sub;" src="./../../assets/images/element.png" alt=""> 粤公网安备 44030302000401号</a>
                </div>
            </div>
        </div>
    </footer>
  </div>
</template>
<script>
export default {
    name:'footer',
    props:{
    	isSub:{
    		type:Boolean,
    		default:false
    	},
    	
    },
}
</script>



<style scoped>
.content2{
    width: 998px;
}
</style>



// WEBPACK FOOTER //
// src/common/footer/footer.vue